const serverURL = "https://bot-designer-server.searchat.com/api";
const livechatURL = "https://i2i-test.azurewebsites.net/api/";
const socketServer = "https://socket.searchat.com/api";
export { 
    serverURL, 
    livechatURL,
    socketServer
};
